import React from 'react';

export const Skeleton: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div
      className={`animate-pulse bg-white/[0.04] rounded-xl ${className}`}
    />
  );
};
